import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboard2LinesLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.92659 3.75C9.59164 3.75 9.32031 4.02133 9.32031 4.35627V4.92933C9.32031 5.26428 9.59164 5.53561 9.92659 5.53561H14.5733C14.9083 5.53561 15.1796 5.26428 15.1796 4.92933V4.35627C15.1796 4.02133 14.9083 3.75 14.5733 3.75H9.92659ZM7.82031 4.35627C7.82031 3.1929 8.76321 2.25 9.92659 2.25H14.5733C15.7367 2.25 16.6796 3.1929 16.6796 4.35627V4.92933C16.6796 6.09271 15.7367 7.03561 14.5733 7.03561H9.92659C8.76321 7.03561 7.82031 6.09271 7.82031 4.92933V4.35627Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.57097 5.34375C6.91185 5.34375 5.56641 6.6892 5.56641 8.34831V17.2458C5.56641 18.9049 6.91185 20.2504 8.57097 20.2504H15.9303C17.5894 20.2504 18.9348 18.9049 18.9348 17.2458V8.34831C18.9348 6.6892 17.5894 5.34375 15.9303 5.34375C15.516 5.34375 15.1803 5.00796 15.1803 4.59375C15.1803 4.17954 15.516 3.84375 15.9303 3.84375C18.4178 3.84375 20.4348 5.86077 20.4348 8.34831V17.2458C20.4348 19.7334 18.4178 21.7504 15.9303 21.7504H8.57097C6.08343 21.7504 4.06641 19.7334 4.06641 17.2458V8.34831C4.06641 5.86077 6.08343 3.84375 8.57097 3.84375C8.98518 3.84375 9.32097 4.17954 9.32097 4.59375C9.32097 5.00796 8.98518 5.34375 8.57097 5.34375Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.48242 10.9531C8.48242 10.5389 8.81821 10.2031 9.23242 10.2031H15.2666C15.6808 10.2031 16.0166 10.5389 16.0166 10.9531C16.0166 11.3673 15.6808 11.7031 15.2666 11.7031H9.23242C8.81821 11.7031 8.48242 11.3673 8.48242 10.9531ZM8.48242 15.4359C8.48242 15.0216 8.81821 14.6859 9.23242 14.6859H15.2666C15.6808 14.6859 16.0166 15.0216 16.0166 15.4359C16.0166 15.8501 15.6808 16.1859 15.2666 16.1859H9.23242C8.81821 16.1859 8.48242 15.8501 8.48242 15.4359Z",
			fill: "currentColor"
		})
	]
});
export default SvgClipboard2LinesLine;
